import clsx from 'clsx';
import React, { ReactNode, useState } from 'react';

import { Button } from '../Button';
import { Container } from '../Container';
import { FlexGrid } from '../FlexGrid';
import { FlexGridItem } from '../FlexGridItem';
import { VisuallyHidden } from '../VisuallyHidden';
import { NewsletterProps } from './Newsletter.types';

export const Newsletter = ({
  id,
  sectionHeader,
  title,
  successMessage,
  isSubmitted = false,
  formProps,
  HiddenFields,
  ReCaptcha,
  onSubmit,
  testId,
}: NewsletterProps): JSX.Element => {
  const [emailAddress, setEmailAddress] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailAddress(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (emailAddress) {
      onSubmit(e);
    }
  };

  return (
    <div
      id={id}
      className={clsx(
        'hds-newsletter',
        'hds-newsletter-mute',
        'section__full-width'
      )}
      data-testid={testId}
    >
      <Container isCentered>
        <FlexGrid isCentered>
          <FlexGridItem xs={12} md={11} lg={8} xl={6} hasMaximumWidth>
            <div className={clsx('section', 'section_xlarge')}>
              <p className='hds-newsletter__eyebrow'>{sectionHeader}</p>
              <h2 className={clsx('hds-newsletter__title', ' text-display_2')}>
                {title}
              </h2>
              <FlexGrid isCentered>
                <FlexGridItem xs={12} md={11} lg={10} lgP={8}>
                  {isSubmitted ? (
                    <Message>{successMessage}</Message>
                  ) : (
                    <form
                      className={clsx('hds-newsletter__form')}
                      onSubmit={handleSubmit}
                      {...formProps}
                    >
                      <div className='hds-newsletter__form-element_addon'>
                        <label
                          className={clsx(
                            'form-element__label',
                            'hds-newsletter__input-label'
                          )}
                        >
                          <VisuallyHidden>Email address</VisuallyHidden>
                          <input
                            name='email'
                            type='email'
                            placeholder='Email address'
                            className={clsx(
                              'text-input',
                              'form-element__text',
                              'hds-newsletter__text-input-round'
                            )}
                            onChange={handleChange}
                            value={emailAddress}
                          />
                        </label>
                        <div className='hds-newsletter__button-addon'>
                          <Button
                            type='submit'
                            buttonType='Primary'
                            classNames={clsx(
                              'hds-newsletter__button-dark',
                              'newsletter-submit'
                            )}
                          >
                            Sign up
                          </Button>
                        </div>
                      </div>
                      {HiddenFields}
                      {ReCaptcha}
                    </form>
                  )}
                </FlexGridItem>
              </FlexGrid>
            </div>
          </FlexGridItem>
        </FlexGrid>
      </Container>
    </div>
  );
};

const Message = ({ children }: { children: ReactNode }) => {
  return (
    <div className={clsx('message', 'message-success')}>
      <div className='message__layout'>
        <div className='message__content'>{children}</div>
      </div>
    </div>
  );
};
